import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoThisIsFor() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const forYou = ['Mamás de bebés de 0 a 24 meses que se sienten al límite del agotamiento.', 'Padres que quieren dormir a sus hijos sin métodos crueles de abandono.', 'Mujeres que trabajan y necesitan descansar para rendir al día siguiente.', 'Familias que buscan una crianza respetuosa y basada en el apego seguro.'];
  const notForYou = ['Personas que buscan "pastillas mágicas" o soluciones que no requieran contacto físico.', 'Quienes prefieren dejar llorar al bebé hasta que se agote por completo.'];
  return <section ref={ref} className="w-full bg-white py-16 md:py-24 px-6" data-id="element-158">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.7
    }} className="max-w-5xl mx-auto" data-id="element-159">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-warm-brown mb-12 text-center" data-id="element-160">
          ¿Es esto para ti?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-161">
          <div className="bg-muted-sage/10 rounded-2xl p-8 border-2 border-muted-sage/30" data-id="element-162">
            <h3 className="font-serif text-2xl font-semibold text-warm-brown mb-6 flex items-center gap-3" data-id="element-163">
              <CheckIcon className="w-7 h-7 text-muted-sage" data-id="element-164" />
              Este método es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-165">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-166">
                  <CheckIcon className="w-5 h-5 text-muted-sage flex-shrink-0 mt-1" data-id="element-167" />
                  <span className="text-warm-brown/90 leading-relaxed" data-id="element-168">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-terracotta/5 rounded-2xl p-8 border-2 border-terracotta/20" data-id="element-169">
            <h3 className="font-serif text-2xl font-semibold text-warm-brown mb-6 flex items-center gap-3" data-id="element-170">
              <XIcon className="w-7 h-7 text-terracotta" data-id="element-171" />
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-172">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-173">
                  <XIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-1" data-id="element-174" />
                  <span className="text-warm-brown/90 leading-relaxed" data-id="element-175">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </motion.div>
    </section>;
}